import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from '../components/components.module';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { MatIconModule } from '@angular/material/icon';
import { S3UploadModule } from '../services/s3-upload/s3-upload.module';
import { ToastrModule } from 'ngx-toastr';
import { LoadingModule } from '../components/loading/loading.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CodeInputModule } from 'angular-code-input';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegistrationComponent,
  },
  {
    path: 'register/:id',
    component: RegistrationComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
];

@NgModule({
  declarations: [
    LoginComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    NgxIntlTelInputModule,
    CodeInputModule,
    MatIconModule,
    S3UploadModule,
    ToastrModule,
    LoadingModule,
    BrowserAnimationsModule, // required animations module
    RouterModule.forChild(routes),
  ],
  exports: [LoginComponent, RegistrationComponent, ForgotPasswordComponent],
})
export class AuthModule {}
